import { useNavigate, useLocation } from 'react-router-dom';
import CONSTANTS from '../../utils/constants';


const determineADFRoute = (adfs) => {

    const hasInprogressAdf = adfs.some(adf => {
        return adf.status !== 'Completed'
    })
    return hasInprogressAdf ? '/connect/sync-your-accounting' : null
}

const determineDLARoute = (dlas) => {

    const hasInprogressDLA = dlas.find(dla => {
        return !dla.dla_end_datetime
    })
    return hasInprogressDLA ? '/journey' : null
}

const determineADFAndDLARoute = (adfs, dlas) => {
    let adfPath, dlaPath = null

    if (adfs.length) {
        adfPath = determineADFRoute(adfs)
    }

    if (dlas.length) {
        dlaPath = determineDLARoute(dlas)
    }
    return adfPath ?? dlaPath
}

const determineInprogressCompaniesNavigation = (userActions) => {

    let path = null

    userActions.companies.some(company => {


        const inprogressActions = company.adfs.length > 0  || company.dlas.length > 0

        if (!inprogressActions) {
            return false
        }

        path = determineADFAndDLARoute(company.adfs, company.dlas)
        return Boolean(path)


    })
    return path ?? '/portal'

}


export default function useRouteNavigator() {

    const navigate = useNavigate()
    const location = useLocation()

    const determineRouteNavigation = (userRole, userActions) => {
        const isSvber = CONSTANTS.INTERNAL_USER_ROLES.includes(userRole)
        if (isSvber) {
            if(!['/', '/verify'].includes(location.pathname)){
                return
            }
            return navigate('/svber/data-management/companies/view');
        }

        const areCompaniesInProgress = userActions.companies?.length > 0

        if (areCompaniesInProgress) {
            const path = determineInprogressCompaniesNavigation(userActions)
            return navigate(path)
        }

        return navigate('/portal')


    }

    return { determineRouteNavigation };
}

const extractSearchParams = <T>(input: string): T => {
  const searchParams = {} as T;
  new URLSearchParams(input).forEach((value, key) => {
    searchParams[key] = decodeURIComponent(value);
  });
  return searchParams;
};

interface SearchParams {
  source: string;
  tab: string;
}
type CustomBackRouteNavigator = { searchParams: SearchParams; goBack: () => void };
/**
 * This hook helps us to build the custom back navigation feature from the source query parameter.
 * @returns { searchParams, goBack: custom goback Function }
 */
export const useCustomBackRouteNavigator = (fallbackURL: string = '/svber/data-management/companies/view'): CustomBackRouteNavigator => {
    const { search } = useLocation()
    const navigate = useNavigate()
    const searchParams = extractSearchParams<SearchParams>(search)
    let goBack = () => navigate(-1) // Default Behaviour to goBack.

    let customBack = (path: string) => {
        return () => {
            navigate(path)
        }
    }

    if (searchParams?.source) {
        goBack = customBack(searchParams.source)
    } else {
        goBack = customBack(fallbackURL)
    }
    return { searchParams, goBack }
}

/**
 * This Hook is used to generate the path with source query parameter based on the current landing page.
 * @returns {string}
 */
export const useLinkWithSrc = (): (targetPath: string) => string => {
  const location = useLocation();
  return (targetPath: string) => {
    return `${targetPath}?source=${encodeURIComponent(location.pathname)}${encodeURIComponent(location.search)}`;
  };
};